import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newPrice =
      event.detail.data.html.querySelector('product-price [ref="priceContainer"]') ||
      event.detail.data.html.querySelector('product-price .pdp-price-block');
    const currentPrice =
      this.querySelector('[ref="priceContainer"]') || this.querySelector('.pdp-price-block');

    if (newPrice && currentPrice && currentPrice.innerHTML !== newPrice.innerHTML) {
      currentPrice.replaceWith(newPrice);
    }

    this.#updateStockRow(event);
  };

  /**
   * Updates the PDP stock row for the selected variant.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  #updateStockRow(event) {
    const newStockRow = event.detail.data.html.querySelector('product-price [ref="stockRow"]');
    const currentStockRow = this.querySelector('[ref="stockRow"]');

    if (newStockRow && currentStockRow) {
      currentStockRow.replaceWith(newStockRow);
      return;
    }

    if (newStockRow && !currentStockRow) {
      this.prepend(newStockRow);
      return;
    }

    if (!newStockRow && currentStockRow) {
      currentStockRow.remove();
    }
  }
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
